import React from 'react';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';

/**
 * Diálogo de advertencia para duplicados detectados
 */
const DuplicateWarningDialog = ({
  open,
  onOpenChange,
  duplicateInfo,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="duplicate-warning-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-orange-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            Producto Ya Analizado
          </DialogTitle>
          <DialogDescription>
            Este producto ya ha sido analizado anteriormente con los siguientes datos:
          </DialogDescription>
        </DialogHeader>

        {duplicateInfo && (
          <div className="space-y-3 py-4">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Cliente:</span>
                <span className="font-semibold">{duplicateInfo.client}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Producto:</span>
                <span className="font-semibold">{duplicateInfo.product}</span>
              </div>
              {duplicateInfo.ensayo && (
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Ensayo:</span>
                  <span className="font-semibold">{duplicateInfo.ensayo}</span>
                </div>
              )}
              {duplicateInfo.fecha_entrada && (
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Fecha Entrada:</span>
                  <span className="font-semibold">{duplicateInfo.fecha_entrada}</span>
                </div>
              )}
            </div>

            <p className="text-center text-sm font-medium text-gray-700 pt-2">
              ¿Desea continuar con la creación del registro?
            </p>
          </div>
        )}

        <DialogFooter className="sm:justify-center gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            className="min-w-[100px]"
            data-testid="duplicate-cancel-btn"
          >
            No, Cancelar
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            className="min-w-[100px] bg-blue-600 hover:bg-blue-700"
            data-testid="duplicate-confirm-btn"
          >
            Sí, Continuar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DuplicateWarningDialog;
